export const screenBreakPoints = {
  sm: "600px",
  md: "767px",
  lg: "1000px",
  xl: "1130px",
  "2xl": "1350px",
} as const;
